/*
 * Copyright © 2018, Rezo Zero
 *
 * @file WaveformScene.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import WaveformManager from '../waveform/WaveformManager'
import { $window } from '../utils/environment'

export default class WaveformScene {
    constructor (p5, sounds) {
        this.p5 = p5
        this.canvas = null
        this.waveFormManager = null
        this.blockAutoScroll = false
        this.canvasWidth = 200
        this.sounds = sounds

        // Binded methods
        this.onResize = this.onResize.bind(this)
        this.onWaveformScroll = this.onWaveformScroll.bind(this)

        this.init()
    }

    init () {
        // Init manager
        this.waveFormManager = new WaveformManager(this.sounds)

        // Init events
        $window.on('resize', this.onResize)
        $window.on('waveform.scroll', this.onWaveformScroll)
    }

    setSounds (sounds) {
        this.sounds = sounds
    }

    destroy () {
        $window.off('resize', this.onResize)
        $window.off('waveform.scroll', this.onWaveformScroll)
        this.waveFormManager.destroy()
    }

    preload (p5) {
        console.log('WaveformScene - preload')
        this.waveFormManager.preload(p5)
    }

    setup () {
        console.log('WaveformScene - setup')
        this.p5._pixelDensity = 1
        this.canvas = this.p5.createCanvas(this.canvasWidth, window.innerHeight)
        this.canvas.id('waveform')
        this.canvas.parent('split-container')

        this.waveFormManager.setup(this.p5)
        this.waveFormManager.setPercent(this.p5)
    }

    draw () {
        this.waveFormManager.draw(this.p5, this.blockAutoScroll)
        this.p5.rectMode('center')
    }

    onWaveformScroll (e, data) {
        if (this.waveFormManager && data.hasOwnProperty('percentY')) {
            this.waveFormManager.setPercent(data.percentY)
        }
    }

    onResize () {
        if (this.canvas) {
            this.p5.resizeCanvas(this.canvasWidth, window.innerHeight)
        }

        this.waveFormManager.onResize(this.p5)
    }

    setAutoScroll (value) {
        this.blockAutoScroll = value
    }

    changeSound () {
        this.waveFormManager.changeSound()
    }
}



// WEBPACK FOOTER //
// ./webpack/js/scenes/WaveformScene.js